import React from 'react';

import DefaultShareImage from '../../assets/default-share2x.png';
import {LoadableView} from '../../state/views/types';
import * as S from './PreviewImageSection.styles';

export const PreviewImageSection = ({
  previewURL,
  view,
}: {
  previewURL: string | undefined;
  view: LoadableView;
}) => {
  return (
    <S.PreviewCard>
      <S.WandbText>wandb.ai</S.WandbText>
      <S.PreviewTitle>{view.displayName}</S.PreviewTitle>
      <S.PreviewDescriptionText>{view.description}</S.PreviewDescriptionText>
      <S.PreviewWrapper>
        <S.StyledImg
          src={previewURL || DefaultShareImage}
          alt="preview-image"
        />
      </S.PreviewWrapper>
    </S.PreviewCard>
  );
};
